<template>
    <div>
        <el-select 
            v-if="mode == 'edit'"
            :ref="reference"
            v-model="tmpValue"
            filterable 
            multiple 
            remote
            :placeholder="prop.placeholder ? prop.placeholder : this.$l10n.__('Rechercher')" 
            :remote-method="remoteMethod"
            :loading="loading"
            @remove-tag="remove"
            class="wp-10">
                <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.fullName"
                :value="parseInt(item.id)">
                </el-option>
        </el-select>
        <person-list v-else :list="options"/>
    </div>
</template>

<script>
    import CfMixin from '../../../mixins/CustomfieldInputsMixins'
    import MultipleMixin from '../../../mixins/MultipleInputsMixins'
    import PersonList from 'vcomponents/utilities/PersonList.vue';

    export default {
        mixins: [CfMixin, MultipleMixin],
        methods: {
            remoteMethod: _.debounce(function(query) {
                if (query !== '') {
                    this.loading = true;
                    
                    // ajax method to get contacts
                    this.$ajax.get(`/rest/contacts/autocomplete`, {q: query},
                        (response) => {
                            this.options = response
                            this.loading = false
                        },
                        (error) => {
                            this.close()
                            Push.error(this.$l10n.__("Problème lors de la récupération des données"))
                        }
                    );

                } else {
                    this.options = [];
                }
            }, 500),
            checkParams(newValue) {
                let valid = true
                valid = this.checkMinMaxParams(newValue)
                return valid
            }
        },

        components: {
            'person-list': PersonList,
        }
    }
</script>
